import { Monitor, Moon, Sun } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useTheme } from "@/providers/ThemeProvider";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";

export function ThemeToggle() {
  const { theme, setTheme, resolvedTheme } = useTheme();
  const { t } = useTranslation();
  const Icon = resolvedTheme === "dark" ? Moon : Sun;
  const switchTheme = (next: "light" | "dark" | "system") => {
    setTheme(next);
    toast.success(t(`common.themeSwitched.${next}`));
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" aria-label={t("common.theme")}>
          <Icon className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => switchTheme("light")} className={theme === "light" ? "bg-accent/40" : ""}>
          <Sun className="mr-2 h-4 w-4" /> {t("common.light")}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => switchTheme("dark")} className={theme === "dark" ? "bg-accent/40" : ""}>
          <Moon className="mr-2 h-4 w-4" /> {t("common.dark")}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => switchTheme("system")} className={theme === "system" ? "bg-accent/40" : ""}>
          <Monitor className="mr-2 h-4 w-4" /> {t("common.system")}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
